// APP
export const APP_CONFIG_FILE: string = './assets/configuration/config.yml';